// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"4d74d8a5","379":"2ca77cb8","702":"a37fdb32","734":"6250f610"}[chunkId] + ".chunk.js";
};